import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { Base_url } from "../config";
import { AesDecrypt } from "../middleware/AesDecrypt";
import { AesEncrypt } from "../middleware/AesEncrypt";

let Header = () => {
  let [ datas , setDatas ] = useState()
  let navigate = useNavigate();

  let logout = () => {
    localStorage.removeItem("token");
    navigate("/login");
  }; 

  const showAlert = () => {
    window.alert("Click OK to run the function."); 
    logout();
  };

  const [isFourToFivePM, setIsFourToFivePM] = useState(false);

  // Function to check the current time
  const checkTime = () => {
    const now = new Date();
    const hours = now.getHours();
    const minutes = now.getMinutes();

    if (hours === 16 && minutes >= 0 && minutes < 60) {
      setIsFourToFivePM(true);
    } else {
      setIsFourToFivePM(false);
    }
  };

  useEffect(() => {
    // Check time immediately
    checkTime();

    // Set an interval to check the time every minute
    const interval = setInterval(checkTime, 60000); // 60000 ms = 1 minute

    // Clean up the interval on component unmount
    return () => clearInterval(interval);
  }, []);

  useEffect(()=>{
    Start()
  },[])

  let Start = async () =>{
    let token = await localStorage.getItem("token");
    let pp = { token };
    let data = await AesEncrypt(pp);

    let apicall = await axios({
      method: "post",
      url: Base_url + "/admin/counts",
      data: {
        data: data,
      },
    })
    .then((re)=>{
      let parsedata = AesDecrypt(re.data);
      let Jsson = JSON.parse(parsedata);
      if (Jsson.status === true) {
        setDatas(Jsson)
        console.log(Jsson , 'lllljkh')
      }else{
        navigate("/login");
        console.log(Jsson , 'llll')
      }

    })
    .catch((err)=>{
      console.log(err , 'jjjj')
    })
  }

  return (
    <div className="col-2" style={{ overflowY : 'scroll' , height : '100vh' , scrollbarWidth : 'none' }}>
      <div
        style={{
          padding: 20,
          width: "100%",
          boxShadow:
            "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
        }}
      >
        <p
          style={{ color: "red" }}
          onClick={() => {
            showAlert();
            sessionStorage.setItem("started", "true");
            sessionStorage.setItem("userind", "0");
          }}
        >
          Logout
        </p>

        <p
          onClick={() => {
            navigate("/dashboard");
            
          }}
        >
          Dashboard
        </p>

        <p
          onClick={() => {
            navigate("/homepage");
          }}
        >
          Master
        </p>

        <ul class="list-unstyled">
          <li>
            <p
              onClick={() => {
                sessionStorage.setItem("started", "true");
                sessionStorage.setItem("userind", "0");
                navigate("/user");
              }}
              style={{ cursor: "pointer" }}
            >
              User
            </p>

            <ul style={{ marginTop: -20 }}>
              <li
                onClick={() => {
                  sessionStorage.setItem("started", "true");
                  sessionStorage.setItem("userind", "0");
                  navigate("/user");
                }}
              >
                User 
              </li> 

               <li
                onClick={() => { 
                  navigate("/userplan");
                }}
              >
                User Plan
              </li>

              <li
                onClick={() => { 
                  navigate("/user_month_offer");
                }}
              >
                User Month offer
              </li>
              <li
                onClick={() => { 
                  navigate("/user_kyc_not_verified");
                }}
              >
                User Kyc Not Verified
              </li> 


            </ul>
          </li>
        </ul>




        {/* <p
          onClick={() => {
            sessionStorage.setItem("started", "true");
            sessionStorage.setItem("userind", "0");
            navigate("/user");
          }}
        >
          User
        </p> */}

        <p
          onClick={() => { 
            navigate("/kyc_notlist");
          }}
        >
          Kyc Not Verified
        </p>

        <p
          onClick={() => { 
            navigate("/videokyc");
          }}
        >
          Video Kyc
        </p>


        <p
          onClick={() => { 
            navigate("/new_payments_utility");
          }}
        >
          New Payments Utility
        </p>


         <p
          onClick={() => { 
            navigate("/new_payments");
          }}
        >
          New Payments Edu
        </p>

        <p
          onClick={() => { 
            navigate("/xapaywallet");
          }}
        >
          Xopay Wallet Payment
        </p>

        <ul class="list-unstyled">
          <li>
            <p
              onClick={() => {
                navigate("/userrent");
              }}
              style={{ cursor: "pointer" }}
            >
              Utility
            </p>

            <ul style={{ marginTop: -20 }}>
              <li
                onClick={() => {
                  navigate("/sameday", { state: "Sameday" });
                }}
              >
                Sameday <span style={{ color : "blue" }} >{'('+datas?.countsameday+')'}</span>
              </li>
              <li
                onClick={() => {
                  navigate("/t1", { state: "T1" });
                }}
              >
                T1 <span style={{ color : "blue" }} >{'('+datas?.countt1+')'}</span>
              </li>
              <li
                onClick={() => {
                  navigate("/t2", { state: "T2" });
                }}
              >
                T2 <span style={{ color : "blue" }} >{'('+datas?.countt2+')'}</span>
              </li>
              <li
                onClick={() => {
                  navigate("/t3", { state: "T3" });
                }}
              >
                T3 
                <span style={{ color : "blue" }} >{'('+datas?.countt13+')'}</span>
              </li>

               <li
                onClick={() => {
                  navigate("/t4", { state: "T4" });
                }}
              >
                T4
                <span style={{ color : "blue" }} >{'('+datas?.countt14+')'}</span>
              </li>



              <li
                onClick={() => {
                  navigate("/chargeback", { state: "verified" });
                }}
              >
                Chargeback <span style={{ color : "blue" }} >{'('+datas?.chargeback+')'}</span>
              </li>

              <li
                onClick={() => {
                  navigate("/verified", { state: "verified" }); 
                }}
              >
                Verified <span style={{ color : "blue" }} >{'('+datas?.bbpsverify+')'}</span>
              </li>

              <li
                onClick={() => {
                  navigate("/reverse", { state: "reverse" });
                }}
              >
                Reverse <span style={{ color : "blue" }} >{'('+datas?.reversee+')'}</span>
              </li>
              
              <li
                onClick={() => {
                  navigate("/freezed", { state: "freeze" });
                }}
              >
                Freezed <span style={{ color : "blue" }} >{'('+datas?.bbpsfrezze+')'}</span>
              </li>

              <li
                onClick={() => {
                  navigate("/verifieddown", { state: "verified" });
                }}
              >
                Verified Downloaded
              </li>
              
            </ul>
          </li>
        </ul>
        {/* <p
          onClick={() => {
            navigate("/userrent");
          }}
        >
          Rent
        </p> */}

        <ul class="list-unstyled">
          <li>
            <p
              onClick={() => {
                navigate("/userrentedu");
              }}
              style={{ cursor: "pointer" }}
            >
              Education Payment
            </p>

            <ul style={{ marginTop: -20 }}>
              <li
                onClick={() => {
                  navigate("/samedayedu", { state: "Sameday" });
                }}
              >
                Sameday <span style={{ color : "blue" }} >{'('+ datas?.countsamedayedu+')'}</span>
              </li>
              <li
                onClick={() => {
                  navigate("/t1edu", { state: "T1" });
                }}
              >
                T1 <span style={{ color : "blue" }} >{'('+datas?.countt1edu+')'}</span>
              </li>
              <li
                onClick={() => {
                  navigate("/t2edu", { state: "T2" });
                }}
              >
                T2 <span style={{ color : "blue" }} >{'('+datas?.countt2edu+')'}</span>
              </li>
              <li
                onClick={() => {
                  navigate("/t3edu", { state: "T3" });
                }}
              >
                T3 
                <span style={{ color : "blue" }} >{'('+datas?.countt2edu3+')'}</span>
              </li>
              <li
                onClick={() => {
                  navigate("/t4edu", { state: "T4" });
                }}
              >
                T4
                <span style={{ color : "blue" }} >{'('+datas?.countt4edu+')'}</span>
              </li>

              <li
                onClick={() => {
                  navigate("/lowedu", { state: "Low" });
                }}
              >
                Low
                <span style={{ color : "blue" }} >{'('+datas?.countt1edulow+')'}</span>
              </li>

              <li 
                onClick={() => {
                  navigate("/chargebackedu", { state: "chargeback" });
                }}
              >
                Chargeback <span style={{ color : "blue" }} >{'('+datas?.chargebackedu+')'}</span>
              </li>
              <li
                onClick={() => {
                  navigate("/verifiededu", { state: "verified" });
                }}
              >
                Verified <span style={{ color : "blue" }} >{'('+datas?.bbpsverifyedu+')'}</span>
              </li>
              <li
                onClick={() => {
                  navigate("/reverseedu", { state: "reverse" });
                }}
              >
                Reverse <span style={{ color : "blue" }} >{'('+datas?.reverseedu+')'}</span>
              </li>
              <li
                onClick={() => {
                  navigate("/freezededu", { state: "freeze" });
                }}
              >
                Freezed <span style={{ color : "blue" }} >{'('+datas?.bbpsfrezzeedu+')'}</span>
              </li>

              <li
                onClick={() => {
                  navigate("/verifiededudown", { state: "verified" });
                }}
              >
                Verified Downloaded
              </li>
            </ul>
          </li>
        </ul>


        <ul class="list-unstyled">
          <li>
            <p
              onClick={() => {
                navigate("/bbps");
              }}
              style={{ cursor: "pointer" }}
            >
              BBps
            </p>

            <ul style={{ marginTop: -20 }}>
              <li
                onClick={() => {
                  navigate("/bbps");
                }}
              >
                Bbps <span style={{ color : "blue" }} >{'('+datas?.bbps+')'}</span>
              </li>
              <li
                onClick={() => {
                  navigate("/bbps_category");
                }}
              >
                BBps Category
              </li>
               <li
                onClick={() => {
                  navigate("/bbps_category_flowise");
                }}
              >
                BBps Flowise
              </li> 
            </ul>
          </li>
        </ul>


        {/* <p
          onClick={() => {
            navigate("/bbps");
          }}
        >
          Bbps <span style={{ color : "blue" }} >{'('+datas?.bbps+')'}</span>
        </p> */}

        <p
          onClick={() => {
            navigate("/allpayment");
          }}
        >
          All Payment
        </p>

        <p
          onClick={() => {
            navigate("/allpaymentfailedsearch");
          }}
        >
          All Payment Failed Check
        </p> 

        <p
          onClick={() => {
            navigate("/blukpayment");
          }}
        >
          Bulk payment Status change
        </p>

        {/* 
        {isFourToFivePM ? (
          <p
            onClick={() => {
              navigate("/notification");
            }}
          >
            Notification
          </p>
        ) : (
          ""
        )} */}

        <p
          onClick={() => {
            navigate("/notification");
          }}
        >
          Notification
        </p>

        <p
          onClick={() => {
            navigate("/reward");
          }}
        >
          Reward
        </p>

        <p
          onClick={() => {
            navigate("/rewarddetail");
          }}
        >
          Reward Detail
        </p>

        <p
          onClick={() => {
            navigate("/feedback");
          }}
        >
          Feedback
        </p>


        <p
          onClick={() => {
            navigate("/rewardcashback");
          }}
        >
          Cashback
        </p>

        <p
          onClick={() => {
            navigate("/rewardcashbackreq");
          }}
        >
          Cashback Request
        </p>

        <p
          onClick={() => {
            navigate("/renteditgateway");
          }}
        >
          FlowWise
        </p>
        <p
          onClick={() => {
            navigate("/cardapply");
          }}
        >
          Card Apply
        </p>


        <p
          onClick={() => {
            navigate("/refer");
          }}
        >
          Refer
        </p>



        <p
          onClick={() => {
            navigate("/other");
          }}
        >
          Other
        </p>


        <p
          onClick={() => {
            navigate("/report");
          }}
        >
          Report
        </p>

        <p
          onClick={() => {
            navigate("/fraud");
          }}
        >
          Fraud
        </p>



      </div>
    </div>
  );
};

export default Header;
